/**
 * Matches lettered sub-section headings in agreement content.
 * Group 1: the letter (e.g. "A")
 * Group 2: the heading text after the letter prefix (e.g. "Interest Rates")
 */
export const LETTERED_HEADING_RE = /^([A-Z])\.\s+(.*)/;
